export default __webpack_public_path__ + "static/media/facebook.50e3a493.png";